import { CollectionIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

// Feature-education placeholder for the second Atlas tab. Renders inside the
// page canvas, so no card border of its own. The Asset Library will hold
// approved verbatim blocks — case studies, boilerplate, snippets — the agent
// may use word-for-word.
function AtlasAssetLibrary() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center text-center py-24">
      <CollectionIcon className="w-10 h-10 text-gray-300" />
      <div className="font-gilroy font-semibold text-lg text-gray-900 mt-4">{t("Asset Library")}</div>
      <div className="text-sm text-gray-400 font-semibold mt-1 max-w-md">
        {t("Approved case studies, boilerplate, and snippets your Context Hub can use word-for-word — so every proof point and security answer is one your team has signed off.")}
      </div>
      <div className="text-xs font-gilroy font-semibold bg-lightblue text-blue rounded px-2 py-1 mt-4">
        {t("Coming soon")}
      </div>
    </div>
  );
}

export default AtlasAssetLibrary;
